import * as z from 'zod'

import { validatePhone } from '@/lib/utils/validation/phoneValidation'
import { UTMDataSchema } from '@/lib/gtm/utmContext'

export const registrationFormSchema = z.object({
  name: z.string().nonempty('กรุณาระบุชื่อของคุณ'),
  surname: z.string().optional(),
  email: z
    .string()
    .email('อีเมล์ไม่ถูกต้อง')
    .nonempty('กรุณาระบุอีเมล์ของท่าน'),
  tel: z
    .string()
    .nonempty('กรุณาระบุเบอร์โทรติดต่อของคุณ')
    .refine((value) => validatePhone(value), {
      message: 'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง',
    }),
  company: z.string().nonempty('กรุณาระบุชื่อบริษัทของคุณ'),
  message: z.string().optional(),
  accept: z.boolean(),
  newsletter: z.boolean(),
  url: z.string(),
});

export const payloadSchema = registrationFormSchema.extend({
  utm: UTMDataSchema,
})

export type PayloadValue = z.infer<typeof payloadSchema>

